//Core
import React, {FC, Suspense, lazy, useEffect} from "react";
import {Navigate, Route, Routes} from "react-router-dom";
//Components
import SideBar from "../sidebar/SideBar";
import Loader from "@/components/shared/loader/Loader";
import FullPageLoader from "@/components/shared/loader/FullPageLoader";
import Snack from "../snack/Snack";
import {MobileHeader} from "@/components/layout/mobileHeader/MobileHeader";
//Styles
import {MainBody} from "./Main.styles";
import {FlexBox} from "@/styles/layout/boxes";
//Hooks
import {useAuth} from "@/utils/hooks/useAuth";
import {usePathname} from "@/utils/hooks/usePathname";
import {useBreakpoints} from "@/utils/hooks/useBreakpoints";
import useMixpanel from "@/utils/hooks/useMixPanel";
import {MixpanelItems} from "@/utils/mixpanelItems";

const HomePage = lazy(() => import("@/components/mainContent/home/HomePage"));
const LoginPage = lazy(() => import("@/components/mainContent/login/LoginPage"));
const GeneralAudiencesPage = lazy(() => import("@/components/mainContent/general/GeneralAudiencesPage"));
const CustomAudiencesPage = lazy(() => import("@/components/mainContent/custom/CustomAudiencesPage"));
const FilesPage = lazy(() => import("@/components/mainContent/files/FilesPage"));
const ExportAudiencesPage = lazy(() => import("@/components/mainContent/export/ExportAudiencesPage"));
const SuccessExportPage = lazy(() => import("@/components/mainContent/successExport/SuccessExportPage"));
// const PixelPage = lazy(() => import("@/components/mainContent/pixel/PixelPage"));
// const FAQPage = lazy(() => import("@/components/mainContent/faq/FAQPage"));
// const SupportPage = lazy(() => import("@/components/mainContent/support/SupportPage"));

const Main: FC = () => {
    const {loading, getToken} = useAuth();
    const {isLoginPage} = usePathname();
    const {tabletScreen} = useBreakpoints();
    const {trackEvent} = useMixpanel();

    const beforeUnloadHandler = () => {
        trackEvent(MixpanelItems.SessionEnd);
    };

    useEffect(() => {
        void getToken();
        trackEvent(MixpanelItems.SessionStart);
        window.addEventListener("beforeunload", beforeUnloadHandler);
        return () => window.removeEventListener("beforeunload", beforeUnloadHandler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) return <FullPageLoader/>;
    else
        return (
            <>
                {tabletScreen ? <MobileHeader/> : <SideBar/>}
                <MainBody isLogin={isLoginPage} className={isLoginPage ? "login" : ""}>
                    <Suspense fallback={<SuspenseLoader/>}>
                        <Routes>
                            <Route path="/" element={<HomePage/>}/>
                            <Route path="login" element={<LoginPage/>}/>
                            <Route path="filter" element={<GeneralAudiencesPage/>}/>
                            <Route path="custom" element={<CustomAudiencesPage/>}/>
                            <Route path="files" element={<FilesPage/>}/>
                            <Route path="export" element={<ExportAudiencesPage/>}/>
                            <Route path="success" element={<SuccessExportPage/>}/>
                            {/* <Route path="pixel" element={<PixelPage/>}/> */}
                            {/*<Route path="faq" element={<FAQPage/>}/>*/}
                            {/*<Route path="support" element={<SupportPage/>}/>*/}
                            {/*<Route path="404" element={<Page404/>}/>*/}
                            <Route path="*" element={<Navigate to={"/"}/>}/>
                        </Routes>
                    </Suspense>
                </MainBody>
                <Snack/>
            </>
        );
};

const SuspenseLoader: FC = () => {
    return (
        <FlexBox height={"100vh"} justifyContent={"center"}>
            <Loader/>
        </FlexBox>
    );
};

export default Main;
